<template>
  <div>
    <vxe-toolbar>
      <template #buttons>
        <!-- <vxe-input
          v-model="filterName_detable"
          type="search"
          placeholder="Input a key word"
          @keyup="searchEvent_detable"
        ></vxe-input> -->
        <vxe-button @click="exportDataEvent"
          ><a-icon type="cloud-download" /> Download</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      row-id="id"
      size="small"
      :row-config="{ height: 35 }"
      ref="xTable"
      :data="tableData_detable"
      :loading="loading"
      align="center"
      header-align="center"
    >
      <vxe-column field="drug" title="CMap ID" type="html">
        <template #default="{ row }">
          <div style="text-align: center; font-weight: bolder; color: #4572a7">
            <a @click="goGeneDrug(row.drug)"> {{ row.drug }}</a>
          </div>
        </template>
      </vxe-column>
      <vxe-column field="scores" title="Scores" type="html">
        <template #default="{ row }">
          <div
            v-if="typeof row.scores !== 'number'"
            style="text-align: center; color: #4572a7"
          >
            <div
              v-for="(index, element) in row.scores.split(',')"
              :key="index"
              :value="element"
            >
              <a-tag style="margin-bottom: 2px; margin-top: 2px">
                {{ index }}</a-tag
              >
            </div>
          </div>
          <div v-else style="text-align: center; color: black">
            {{ row.scores }}
          </div>
        </template>
      </vxe-column>
      <template #empty>
        <span style="color: grey">
          No records, please select a partition!
        </span>
      </template>
    </vxe-table>

    <vxe-pager
      background
      size="small"
      :loading="loading_detable"
      :current-page="tablePage_detable.currentPage"
      :page-size="tablePage_detable.pageSize"
      :total="tablePage_detable.totalResult"
      :page-sizes="[10, 20, 50]"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        // 'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange_table"
    >
    </vxe-pager>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";

export default {
  // components: { downloadexcel },
  props: ["value"],
  data() {
    return {
      webiste: "http://research.gzsys.org.cn/perturbdb",
      //加载
      loading: false,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  watch: {
    value() {
      this.loading = true;
      //测试
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/drug/gene/searchPart.php",
          {
            params: {
              gene: this.$route.query.gene,
            },
          }
        )
        .then((response) => {
          //同一转一下.
          console.log(this.value);
          this.getdata_detable = response.data[this.value];
          this.findList_detable(this.getdata_detable);
          this.loading = false;
        });
    },
  },
  created() {
    //测试
    // axios
    //   .get(
    //     "http://research.gzsys.org.cn/perturbdb/API/drug/gene/searchPart.php",
    //     {
    //       params: {
    //         gene: this.$route.query.gene,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.getdata_detable = response.data["SC00003"];
    //     this.findList_detable(this.getdata_detable);
    //     this.loading = false;
    //   });
  },

  methods: {
    goGeneDrug(value) {
      let routeData = this.$router.resolve({
        name: "drugModelResult",
        query: { drugid: value },
      });
      window.open(routeData.href, "_blank");
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.value + "_partitions_Predicted_drugs",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: this.filterName_detable + "_related_perturbed_gene",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goQuickSearch(value) {
      let href = this.webiste + "/#/quickSearch?gene=" + value;
      window.open(href, "_blank");
    },
    goDataset(value, value2) {
      let href =
        this.webiste +
        "/#/perturbedgenes?datasetId=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    // goGeneDrug(value) {
    //   let href =
    //     "http://research.gzsys.org.cn/perturbdb/#/drugGeneResult?gene=" + value;
    //   window.open(href, "_blank");
    // },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["genesymbol", "ensemble"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
</style>
